import {
  Button,
  Modal,
  ModalProvider,
  SecondaryButton,
  typography,
} from '@joor/design-system'
import styled from 'styled-components'

import usePortal from 'hooks/usePortal'

export const StyledContent = styled.p`
  ${typography.alpha.primaryActive.body1}
`

export const StyledActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
  order: 3;
  gap: 15px;
  padding: 16px 24px 0 16px;
  margin: 0;
  border-top: 1px solid var(--color-primary-200);
`

type CancelOrderModalProps = {
  isOpen: boolean
  setOpen: (isOpen: boolean) => void
  action: () => void
}

const CancelOrderModal = ({
  isOpen,
  setOpen,
  action,
}: CancelOrderModalProps) => {
  const Portal = usePortal()
  return (
    <Portal>
      <ModalProvider>
        <Modal
          isOpen={isOpen}
          onClose={(): void => setOpen(false)}
          title={{ text: 'Do you want to cancel this order?' }}
          size="medium"
        >
          <StyledContent>
            If you resolve the errors, you can take other actions on this order.
          </StyledContent>
          <StyledActions>
            <SecondaryButton onClick={() => setOpen(false)}>
              Go Back
            </SecondaryButton>
            <Button onClick={action}>Yes, Cancel Order</Button>
          </StyledActions>
        </Modal>
      </ModalProvider>
    </Portal>
  )
}

export default CancelOrderModal
